/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../../base/BaseComponent";
import { Modal} from "antd";
import ChoiceType from '../../components/ChoiceType';
import {changeSize, formatTime, uuid} from "../../../../utils";
import '../../style/public.css'
import PageTableComponent from "../../components/pageTable/PageTable";
import {HEADER_HEIGHT} from "../../../../constants";
import Detailpage from "../../components/DetailPage";
import {message} from '../../components/Mess'
import $ from "jquery";
const {confirm} = Modal;



export default class Collection extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state={
            typeList:[],//全部类型
            selectType:[],//选中的类型
            searchText:'',//搜索的文字
            backList:[],//返回列表
            startTime:'',//开始时间
            endTime:'',//结束时间
            page:1,
            size:10,
            data:[],
            modalKey:uuid()

        }
    }

    componentWillMount() {

    }

    componentDidMount() {

       this.getList()

    }



    render() {

        return (

            <div style={{background: '#ffffff',

                padding: '24px 32px 16px 32px',
                margin: "15px 0 15px 15px",

                position: 'relative',
                borderRadius:5}}>
                {/*渲染选择框以及下载 功能*/}
                {this.renderBtn()}
                {/*渲染当前位置*/}
                {/*渲染数据*/}
                {this.renderData()}
            </div>
        )
    }
    renderBtn(){
        return(
            <div style={{lineHeight:'45px'}}>
                <ChoiceType onSaveCallback={(searchText,selectType,startTime,endTime)=>{
                    this.setState({searchText:searchText,selectType:selectType,startTime:startTime,endTime:endTime,page:1},()=>{
                        this.getList()
                    })
                }}></ChoiceType>
            </div>

        )
    }
    renderData(){
        let  columns=[
            {
                title: '名称',
                dataIndex: 'name',
                width:600,
                ellipsis: true,
                render: (text, record) =>{
                    let title=text;
                    return (<div style={{display:'flex',cursor:'pointer'}} title={'text'} onClick={()=>{this.getDetailPage(record)}}>
                            <img src={record.icon} style={{width:'24px',height:'24px',objectFit: "contain"}}/>
                            <div title={title} className={'twoText'} style={{ marginLeft: '8px'}}>{text}</div>
                    </div>)
                }
            },
            {
                title: '收藏时间',
                dataIndex: 'createTime',
                width:300,
                render: (text, record) => {
                    return (<div>{formatTime(text)}</div>)
                }
            },
            {
                title: '大小',
                dataIndex: 'size',
                width:100,
                render: (text, record) => {
                    return (<div>{text>0?changeSize(text):0+'kb'}</div>)
                }
            },
            {
                title: '操作',
                dataIndex: 'address',
                width:200,
                align:'center',
                render: (text, record) =>{
                    let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
                    return (<div style={{color:newSecondSelectColor,}}>
                        <span style={{cursor:"pointer"}} onClick={()=>{
                            this.cancelCollection(record)
                        }}>取消收藏</span>
                    </div>)
                }},
        ];
        return(
           <div>
            <PageTableComponent columns={columns}
                                rowSelection={null}
                                data={this.state.data}
                                page={this.state.page}
                                size={this.state.size}
                                count={this.state.count}
                                onChangePage={(page, size)=>{
                                    this.onChangePage(page, size)
                                }}
            ></PageTableComponent>

               <Detailpage   key={this.state.modalKey} onRef={(Detailpage) => this.setDetailpage = Detailpage}
                             onCloseCall={() => {
                                 this.getList()
                                 this.setState({modalKey: uuid()})
                             }}
                             dataList={this.state.data}></Detailpage>
           </div>

        )
    }
    //详情页
    getDetailPage(item) {
        this.setDetailpage.show(true,item)
    }
    cancelCollection(record){
        confirm({
            title: '确定要将所选项取消收藏？',
            onOk:()=>{
                this.request({
                    url: "/cm-sites-storage-management/zykCollection/cancel",
                    method: "get",
                    body: {collectionId: record.id},
                    callBack: (data) => {
                        if (data) {
                            message.success('取消收藏成功');
                            if (this.state.data.length === 1) {
                                this.onChangePage(this.state.page - 1, this.state.size)
                            } else {
                                this.onChangePage(this.state.page, this.state.size)
                            }

                        }
                    }
                });
            },
            onCancel() {
            },
        });
    }

    onChangePage(page, size) {
        this.setState({page: page, size: size}, () => {
            this.getList()
        })
    }

    getList() {
        let parms={};
        if (this.state.selectType.length) {
            parms.suffix = this.state.selectType
        }
        if (this.state.searchText) {
            parms.name = this.state.searchText
        }
        if (this.state.startTime) {
            let createTime  = {
                startTime: this.state.startTime,
                endTime: this.state.endTime
            };
            parms.createTime = createTime
        }
        this.request({
            url: "/cm-sites-storage-management/zykCollection/pageList?page="+this.state.page+'&size='+this.state.size,
            method: "post",
            body: parms,
            contentType: "json",
            callBack: (data) => {
                this.setState({data: data.data, count: data.count},()=>{
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })
            }
        });

    };













}